// core version + navigation, pagination modules:
import Swiper from "../../_vendor/node_modules/swiper/";
import { EffectFade, Autoplay, Navigation } from "../../_vendor/node_modules/swiper/modules";

// init Swiper:
new Swiper("[data-swiper]", {
  // configure Swiper to use modules
  modules: [EffectFade, Autoplay, Navigation],
  wrapperClass: "swiper-wrapper",
  slideClass: "swiper-slide",
  effect: "fade",
  crossFade: true,
  loop: true,
  speed: 600,
  autoplay: {
    delay: 6000,
    disableOnInteraction: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true
  //   }
});
